import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface OverheadRateSelection {
	siteLocationId: string;
	subLocationId: string | null;
}

export interface OverheadRateState {
	selected?: OverheadRateSelection;
}

const initialState: OverheadRateState = {};

export const overheadRateSlice = createSlice({
	initialState,
	name: "overheadRate",
	reducers: {
		setOverheadSelection: (state, action: PayloadAction<OverheadRateSelection | null>) => {
			if (action.payload === null) {
				state.selected = undefined;
				return;
			}
			state.selected = {
				siteLocationId: action.payload.siteLocationId,
				subLocationId: action.payload.subLocationId
			};
		}
	}
});

export const { setOverheadSelection } = overheadRateSlice.actions;
export default overheadRateSlice.reducer;
